
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  ExamV2Custom,
  StructExamScoreConfig,
  Vir
} from "@/lib/model/exambuilder/exam-v2";
import Step1 from "./step1.vue";
import Step2 from "./step2.vue";
import Step3 from "./step3.vue";
import Step4 from "./step4.vue";
import Step5 from "./step5.vue";

@Component({
  components: { Step1, Step2, Step3, Step4, Step5 }
})
export default class Config extends Vue {
  @Prop({}) exam!: ExamV2Custom;
  @Prop({}) currentStep!: number;
  @Prop({}) isEdit!: boolean;
  open = false;
  // 需要拉数据的接口  在这个文件里做，分配到各个子组件

  created() {
    //
  }
  mounted() {
    // console.log(a);
  }

  show(i: number): boolean {
    return this.currentStep + 1 === i;
  }
  ok(param?: any, type?: string) {
    this.change(param, type);
    this.close();
  }
  close(p?: any) {
    this.open = false;
  }
  //新建时 缓存输入数据
  change(param?: any, type?: string) {
    this.$emit("getInfo", param, type);
    this.$emit("change");
  }
  // 禹霖 *********************************************
  // yours code here

  //****** end ******

  // 翊彭 *********************************************

  //****** end ******
}
